import { Spinner } from "neetoui";

const PageLoader = () => (
  <div className="flex h-screen items-center justify-center">
    <Spinner />
  </div>
);

export default PageLoader;
